// extracted by mini-css-extract-plugin
export default {"layoutSwitcherMenu":"xixMt0"};